import {
    Component,
    OnInit,
    Input,
    Injectable,
    ChangeDetectorRef,
    ViewChild,
    ElementRef, Output, EventEmitter,
} from '@angular/core';
import {ApplicationService} from 'app/services/application.service';
import {StatusService} from 'app/services/status.service';
import {AuthWebService} from 'app/services/authweb.service';
import {UtilityServiceService} from 'app/services/utility-service.service';
import {ToastrService} from 'ngx-toastr';
import {
    Router,
    ActivatedRoute,
    Params,
    RouteConfigLoadStart,
} from '@angular/router';
import {VehicleEntryService} from 'app/services/vehicle-entry.service';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {CountryService} from 'app/services/country.service';
import {VehicleMakeService} from 'app/services/vehicle-make.service';
import {VehicleTypeService} from 'app/services/vehicle-type.service';
import {environment} from '../../../../src/environments/environment';
import {
    NgbCalendar,
    NgbDateAdapter,
    NgbDateParserFormatter,
    NgbDateStruct,
    NgbActiveModal,
    NgbModal,
    NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {ToastNotificationService} from 'app/shared/toast-notification/toast-notification.service';
import {VehicleService} from 'app/services/vehicle.service';
import {Location, DatePipe} from '@angular/common';
import {PermitTypeService} from 'app/services/permit-type.service';
import {VehicleEntryCarrierService} from 'app/services/vehicle-entry-carrier.service';
import {PopupService} from 'app/services/shared/popup.service';
import {Baseservice} from 'app/services/baseservice';
import {DocumenttypeService} from 'app/services/documenttype.service';
import {DocumentsServiceService} from 'app/services/documents-service.service';
import {DomSanitizer} from '@angular/platform-browser';
import {ReturnStatement} from '@angular/compiler';
import {ConfirmDialogService} from 'app/services/shared/confirm-dialog/confirm-dialog.service';
import {PDFDocumentProxy} from 'ng2-pdf-viewer';
import {FilterService} from '../../shared/filter/filter.service';
import {CarrierDepotService} from '../../carrier-depot/service/carrier-depot.service';
import {CarrierService} from 'app/services/carrier.service';
import { OcasService } from 'app/ocas/Service/ocas.service';
import { StorageService } from 'app/services/storage.service';

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
    readonly DELIMITER = '/';

    fromModel(value: string | null): NgbDateStruct | null {
        if (value) {
            let date = value.split(this.DELIMITER);
            return {
                day: parseInt(date[0], 10),
                month: parseInt(date[1], 10),
                year: parseInt(date[2], 10),
            };
        }
        return null;
    }

    toModel(date: NgbDateStruct | null): string | null {
        return date
            ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
            : null;
    }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
    readonly DT_FORMAT = 'DD/MM/YYYY';

    parse(value: string): NgbDateStruct {
        if (value) {
            value = value.trim();
            let mdt = moment(value, this.DT_FORMAT);
        }
        return null;
    }

    format(date: NgbDateStruct): string {
        if (!date) {
            return '';
        }
        let mdt = moment([date.year, date.month - 1, date.day]);
        if (!mdt.isValid()) {
            return '';
        }
        return mdt.format(this.DT_FORMAT);
    }
}

declare var $;

@Component({
    selector: 'app-manage-vehicles',
    templateUrl: './manage-vehicles.component.html',
    styleUrls: ['./manage-vehicles.component.scss'],
    providers: [
        {provide: NgbDateAdapter, useClass: CustomAdapter},
        {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter},
        NgbActiveModal,
    ],
})
export class ManageVehiclesComponent implements OnInit {
    @Input('ctrlData') ctrlData: any;
    permits: any = [];
    @Input()
    currentDate = {
        day: new Date().getDate(),
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
    };
    statuses: any = [];
    flags = {
        flagAN: 1,
        flagNM: 1,
        flagLU: 1,
        flagCT: 1,
        flagAP: 1,
        flagPT: 1,
        flagST: 1,
        flagDS: 1,
    };
    ranks = {
        flagAN: 1,
        flagNM: 2,
        flagLU: 3,
        flagCT: 4,
        flagAP: 5,
        flagPT: 6,
        flagST: 7,
        flagDS: 8,
    };
    sortLabels = {
        flagAN: 'AccountNumber',
        flagNM: 'Name',
        flagLU: 'LeadUser',
        flagCT: 'CarrierType',
        flagAP: 'ApplicationNumber',
        flagPT: 'PermitType',
        flagST: 'Status',
        flagDS: 'DateSubmitted',
    };
    direction: boolean = false;
    criteria = 'DateSubmitted';
    rankCtrl: number = 8;
    selectedVehicle: any = null;
    isLoading: Boolean = false;
    message: string = 'Loading  vehicles, please wait...';
    statuses1: any = [];
    currentpage: any = 1;
    isExternalRole: boolean = true;
    //Search Variables
    eNatisCounter = 0;
    vehicletypes: any = [];
    permittypes: any = [];
    vinnumber: string;
    vehicleType: string = '';
    permitType: string = '';
    regnumber: string;
    carriername: string;
    carriercode: string;
    found = false;
    keyword: any = {};
    currentPage = 1;
    isEmpty: boolean = false;
    IsSearching: boolean = false;
    IsAdmin: boolean = false;
    pageSize: any = 10;
    count: number = 0;
    disabled = false;
    ShowFilter = false;
    limitSelection = false;
    selectedItems: any = [];
    isManageVehicles: boolean = false;
    dropdownSettings: any = {};
    registerNumber: string;
    isDef: boolean = true;
    vehicleRes: any = [];
    isEditData: boolean = false;
    isViewData: boolean = false;
    myForm: FormGroup;
    ddlCountries: any = [];
    ddlDepots: any = [];
    list_vehicle_make: any = [];
    list_vehicle_type: any = [];
    list_vehicle_types: any = [];
    selectedVMake: any;
    btnAddNew: boolean;
    leased: any;
    appid: any = null;
    @Input() dataCntrl: any;
    @Input() currentCarrierId: any;
    isMyVehicles = false;
    permit_type_id: any;
    isSame = false;
    myAppVehicles = [];
    isPermitApplication: boolean = true;

    model: NgbDateStruct;
    date: { year: number };
    selectedVehicles: any = [];
    selectedCountry: any = null;
    selectedDepot: any = null;

    carrierId: any;
    isVehicleLoading: boolean = false;
    isDocumentLoading: boolean = false;
    uploadedDocs;
    maxMB: any = '5MB';
    dtype: any = 'PDF,JPG,PNG,JPEG';
    docTypeId: any;
    filebytes: string;
    filename: any;
    filetype: any;
    isPhonePortrait = false;
    subIndex: any;
    isHandsetLandscape = false;
    filedescription: string;
    filesize: any;
    user = {LastName: ''};
    vehicleId: number;
    documentType: any;
    isLoadingImg: boolean;
    selectItem: any;
    viewDocuments: any = [];
    DocumentsToUpload: any = [];
    pdfSrc: any;
    img: any;

    linkedDocs: any;
    isExtra: boolean;
    eNatisResult: any = null;

    isReplacement: boolean = false;
    vehiclesReplacement: any = [];
    vehiclesReplace: any = [];
    isSouthAfrica = true;
    disallowEdit = false;
    currentVehicle: any = [];
    classMessage: string;
    wrongClass: boolean;
    curr_permit_type_id: number;
    freight_passenger_ind: any;
    vehicleGVMs: any = [];
    isReset: boolean = false;
    
    @Input() stepperCarrierId;
    @Input() stepperCarrierCode;
    @ViewChild('country_id') mySelectedCountry: ElementRef<HTMLSelectElement>;
    @Output() prevNext = new EventEmitter();

    constructor(
        private toastr: ToastrService,
        private vehicleEntryService: VehicleEntryService,
        private countryService: CountryService,
        private vehicleMakeService: VehicleMakeService,
        private authWebService: AuthWebService,
        private vehicleTypeService: VehicleTypeService,
        private permitTypeService: PermitTypeService,
        public utility: UtilityServiceService,
        private ngbCalendar: NgbCalendar,
        private dateAdapter: NgbDateAdapter<string>,
        private router: Router,
        private activeRoute: ActivatedRoute,
        private vehicleService: VehicleService,
        private responsive: BreakpointObserver,
        private _location: Location,
        private formBuilder: FormBuilder,
        private datePipe: DatePipe, private carrierService: CarrierService,
        private toastService: ToastNotificationService,
        private applicationService: ApplicationService,
        private vehicleEntryCarierService: VehicleEntryCarrierService,
        private msgService: PopupService,
        private documenttypeSerivce: DocumenttypeService,
        private documentService: DocumentsServiceService,
        private ref: ChangeDetectorRef,
        private sanitizer: DomSanitizer,
        private showModal: PopupService,
        private filter: FilterService,
        private confirmDialogService: ConfirmDialogService,
        private carrierDepotService: CarrierDepotService,
        private _ocas:OcasService,
        private storageService: StorageService
    ) {
        //NB.LG Code running in parallel so we moved it to nginit
        // this.activeRoute.params.subscribe((params: Params) => {
        //     this.appid = params['appid'];
        //     console.log(this.appid, 'APPID');
        //     this.carriercode = params['carriercode'];
        //     if (this.carriercode) {
        //         this.isPermitApplication = false;
        //     }
        //     this.carrierId = params['carrierid'];

        //     if (!this.carrierId) {
        //         console.log('Carrier Check =', this.dataCntrl);
        //         this.carrierService.getById(this.dataCntrl?.caarrierId).subscribe((data: any) => {

        //             this.carrierId = data.id;

        //         });
        //     }
        //     console.log('carriercode: ' + this.carriercode);
        //     this.getApp(params['appid']);
        // }); 
        // if (this.router.url.indexOf('vehicle-replace') > 0) {
        //     this.activeRoute.params.subscribe((params: Params) => {
        //         this.appid = params['appid'];
        //         console.log(this.appid, 'APPID&&&&&&&&&&&&&&&&&&&&&&&');
        //         this.getApp(params['appid']);
        //     });
        //     this.isReplacement = true;
        // }
        
    }

    ngOnInit() {


        
        this.responsive
            .observe([Breakpoints.HandsetLandscape, Breakpoints.TabletLandscape])
            .subscribe((result) => {
                this.isPhonePortrait = false;
                this.isHandsetLandscape = false;

                if (result.matches) {
                    this.isPhonePortrait = true;
                }
                if (result.matches) {
                    this.isHandsetLandscape = true;
                }
            });
        this.isManageVehicles = this.router.url.indexOf('vehicles') > 0;
        if (
            environment.authWebApi.systemData != null &&
            environment.authWebApi.systemData.Configurations != null
        ) {
            this.maxMB = environment.authWebApi.systemData.Configurations.find(
                (p) => p.Code == 'MaxUploadMB1'
            ).Value;
            this.dtype = environment.authWebApi.systemData.Configurations.find(
                (p) => p.Code == 'UploadDocTypes1'
            ).Value;

            
        }

        console.log('this.stepperCarrierId', this.stepperCarrierId,);
        if (this.stepperCarrierId) {
            console.log('this.stepperCarrierId', this.stepperCarrierId,);
            this.carrierId = this.stepperCarrierId;
            this.isPermitApplication = false;
        }

        if (this.stepperCarrierCode) {
            this.carriercode = this.stepperCarrierCode;
        }

        this.createForm();
        this.activeRoute.params.subscribe((params: Params) => {
                this.appid = params['appid'];
                this.carriercode = params['carriercode'];
                if (this.carriercode) {
                    this.isPermitApplication = false;
                }
            });
         if (this.router.url.indexOf('vehicle-replace') > 0) 
            this.isReplacement = true;

        this.utility.page = 1;
        this.getApp(this.appid);
        this.initKeyword();
        this.listCountries();
        this.getVehicleMake();
        //this.getVehicles();
        this.loadvehicletypes();
        this.getPermitTypes();
        //this.listDepot();
        // this.getVehiclesGVM();
        this.permitTypeService.getVehiclesGVM().subscribe((data: any) => {
            this.vehicleGVMs = data;
           // console.log('GVMs', this.vehicleGVMs);
           // console.log('user ', this.storageService.getID());
            this.isLoading = false;
        });

        this.documenttypeSerivce.getAll().subscribe((res: any) => {
            //console.log(res);
            this.uploadedDocs = [];
            if (res != null && res.length > 0) {
                this.uploadedDocs = res?.filter((map) => {
                    return map.is_for_vehicle == true;
                });
                this.uploadedDocs = this.uploadedDocs?.filter(
                   // (x) => x.description !== 'Travel Itinerary' || x.description !== 'SARS Tax Clearance Certificate ' ||  x.description !== 'South African ID' || x.code !== 'SAID-PSS-NTS' || x.code !== 'SARS-STAT '
                (x) => { return ((x.code !== 'SAID-PSS-NTS') && (x.code !== 'SARS-STAT ') && (x.code !== 'TRAV-ITIN') && (x.code !== 'MT-VH-LIC')) }

                );

               // console.log('required docs before')
               // console.log(this.uploadedDocs)
                this.getUploadDocs();
               // console.log("after...")
               // console.log(this.uploadedDocs)
            }
        });

        this.user.LastName = this.authWebService.userData
            ? this.authWebService.userData.User.LastName
            : '';
        this.selectedCountry = 'South Africa';
        this.disable();

        if (!this.authWebService.userData.Roles[0].IsExternalRole) {
            this.isExternalRole = false;
        }
    }

    createForm() {
        this.isEditData = false;
        this.isViewData = false;
        this.isSouthAfrica = true;
        this.myForm = this.formBuilder.group({
            id: [-1, []],
            permit_id: [],
            country_id: ['', [Validators.required]],
            registration_number: ['', [Validators.required]],
            registration_year: ['', [Validators.required]],
            depot_id: [''],
            vehicle_make_id: ['', []],
            vehicle_series: ['', []],
            vehicle_model: ['', []],
            vehicle_colour: ['', []],
            vin: ['', [Validators.required]],
            engine_number: ['', [Validators.required]],
            gvn: ['', [Validators.required]],
            seating_capacity: ['', []],
            date_license_expiry: ['', [Validators.required]],
            start_date: ['', [Validators.required]],
            vehicle_state: ['', []],
            roadworthy_status: ['', [Validators.required]],
            vehicle_owner: ['', []],
            is_leased: [null, [Validators.required]],
            vehicle_lessor: [''],
            vehicle_lessee: [''],
            date_lease_expiry: [''],
            vehicle_type_id: ['', [Validators.required]],
            api_date_updated: ['', []],
            eNatis_num: ['', []],
        });
        this.disable();
        this.LeaseChange(event); // hides the lease container
        this.found = false; // hides the 'Retrieve from eNatis' button
        this.disallowEdit = false; // allow fields to be edited
        this.myForm.controls.country_id.enable();
        this.myForm.controls.roadworthy_status.enable();
        this.myForm.controls.vehicle_type_id.enable();
        this.myForm.controls.is_leased.enable();
        this.DocumentsToUpload = [];
        this.viewDocuments = [];
        this.uploadedDocs = this.uploadedDocs?.filter(
           // (x) => x.description !== 'Travel Itinerary' && x.description !== 'SARS Tax Clearance Certificate ' && x.description !== 'South African ID'&& x.code !== 'SAID-PSS-NTS' && x.code !== 'SARS-STAT '
           (x) => { return ((x.code !== 'SAID-PSS-NTS') && (x.code !== 'SARS-STAT ') && (x.code !== 'TRAV-ITIN') && (x.code !== 'MT-VH-LIC') && x.is_for_vehicle == true) }
        );
        this.selectedCountry = 'South Africa';
    }

    passForEdit(item) {
        //console.log(item);
        this.isEditData = true;
        this.vehicleService.getVehicleBy(item.id).subscribe((x: any) => {
            //console.log(x);
            this.leased = x.is_leased;
            this.myForm.patchValue({
                id: item.id,
                date_license_expiry: this.datePipe.transform(
                    item.date_license_expiry,
                    'dd/MM/yyyy'
                ),
                gvn: item.gvn,
                registration_number: item.registration_number,
                registration_year: item.registration_year,
                depot_id: item.depot_id,
                seating_capacity: x.seating_capacity,
                start_date: item.start_date,
                vehicle_make_id: item.vehicle_make_id,
                vehicle_type_id: item.vehicle_type_id,
                vin: item.vin,
                permit_id: x.permit_id,
                country_id: x.country_id,
                vehicle_series: x.vehicle_series,
                vehicle_model: x.vehicle_model,
                vehicle_colour: x.vehicle_colour,
                engine_number: x.engine_number,
                vehicle_state: x.vehicle_state,
                roadworthy_status: x.roadworthy_status,
                vehicle_owner: x.vehicle_owner,
                is_leased: x.is_leased,
                vehicle_lessor: x.vehicle_lessor,
                vehicle_lessee: x.vehicle_lessee,
                date_lease_expiry: this.datePipe.transform(
                    x.date_lease_expiry,
                    'dd/MM/yyyy'
                ),
            });
        });
    }

    checkVin(value) {
        try{
        if (value.length > 0) {
            // if (this.selectCountry != null) {
            //   return this.toastService.error("Please select the vehicle's Country-of-Registration before continuing.",'Vehicle')
            // }
            console.log('', this.selectedCountry);
            if (this.selectedCountry == 'South Africa') {
                // this.eNatisUpdate();
                // this.found = true; // displays the "Retrieve from eNatis" button
                // this.disable();
            }
        } else {
            // if (value.length === 0) {
            this.found = false; // hides the "Retrieve from eNatis" button
            this.enable();
            // }
        }

        // if (value.length === 17){
        // this.vehicleService.getVehicleValidatorByVin(this.myForm.value.vin)
        // .subscribe((data: any) => {
        //     if (data.Vin == null) {
        //         this.found = false; // hides the "Retrieve from eNatis" button
        //         this.enable();
        //         return;
                
        //     }
        // });
        // }  

        if (value.length === 17 && this.selectedCountry == 'South Africa') {
            this.eNatisUpdate();
        }
    }
    catch (error) {
        this.toastService.error(error, 'Vehicle');
        this.myForm.reset();
        return;
    }
    }

    eNatisUpdateUsingRegNum() {
        try{
        this.vehicleService
            .getVehicleValidatorByVin(this.myForm.value.registration_number)
            .subscribe((data: any) => {

                if (data.Vin !== null) {
                    //console.log(data);
                    this.eNatisResult = data;
                    this.myForm.patchValue({
                        country_id: 113,
                        vin: data.Vin,
                        registration_number: data.Registration_number,
                        vehicle_owner: data.Ownership,
                        registration_year: data.Registration_year,
                        vehicle_colour: data.Vehicle_colour,
                        vehicle_model: data.Vehicle_model,
                        gvn: data.Gvm,
                        engine_number: data.Engine_number,
                        roadworthy_status: data.roadworthystatus,
                        eNatis_num: data.enatis_num,
                        date_license_expiry: this.datePipe.transform(
                            data.Date_license_expiry,
                            'dd/MM/yyyy'
                        ),
                        seating_capacity: data.Seating_capacity,
                    });
                    //  return this.toastr.success('Vehicle data found successfully on eNAtis database. Please add your vehicle.')
                }
                else{
                    this.toastService.error('VIN not found put a correct VIN', 'Vehicle');
                    this.myForm.reset();
                    return;
                }
                if (data.NotFound === 'Not found') {
                    this.toastService.error('VIN and reg num do not match.', 'Vehicle');
                    this.myForm.reset();
                    return;
                }
                if (data.NetworkError === 'Network error') {
                    this.myForm.reset();
                    // this.toastr.error('The system is offline at the moment, please try again later.')
                    return;
                }
            });
        }
        catch (error) {
            this.toastService.error(error, 'Vehicle');
            this.myForm.reset();
            return;
        }
    }

    eNatisForUpdate() {
        try{
        this.eNatisCounter += this.eNatisCounter;
        this.isVehicleLoading = true;
        this.vehicleService
            .getVehicleValidatorByVin(this.myForm.value.vin)
            .subscribe(
                (data: any) => {
                    if (data.Vin !== null) {
                        //console.log(data);
                        this.eNatisResult = data;
                        this.myForm.patchValue({
                            country_id: 113,
                            vin: data.Vin,
                            registration_number: data.Registration_number,
                            vehicle_owner: data.Ownership,
                            registration_year: data.Registration_year,
                            vehicle_colour: data.Vehicle_colour,
                            vehicle_model: data.Vehicle_model,
                            gvn: data.Gvm,
                            engine_number: data.Engine_number,
                            roadworthy_status: data.roadworthystatus,
                            eNatis_num: data.enatis_num,
                            date_license_expiry: this.datePipe.transform(
                                data.Date_license_expiry,
                                'dd/MM/yyyy'
                            ),
                            seating_capacity: data.Seating_capacity,
                        });
                        this.isVehicleLoading = false;
                        this.isSouthAfrica = true;
                        this.disallowEdit = true;
                    }
                },
                (error) => {
                    this.isVehicleLoading = false;
                }
            );
        }
        catch (error) {
            this.toastService.error(error, 'Vehicle');
            this.myForm.reset();
            return;
        }
    }

    eNatisUpdate() {
        
        try{
        this.eNatisCounter = this.eNatisCounter + 1;
        this.isVehicleLoading = true;
        // this.found = false
        this.message = 'Checking vehicle, please wait...';
        this.vehicleService.getVehicleValidatorByVin(this.myForm.value.vin).subscribe((data: any) => {
                if (data.Vin !== null) {
                    this.eNatisResult = data;
                    this.myForm.patchValue({
                        country_id: 113,
                        vin: data.Vin,
                        registration_number: data.Registration_number,
                        vehicle_owner: data.Ownership,
                        registration_year: data.Registration_year,
                        vehicle_colour: data.Vehicle_colour,
                        vehicle_model: data.Vehicle_model,
                        gvn: data.Gvm,
                        engine_number: data.Engine_number,
                        roadworthy_status: data.roadworthystatus,
                        eNatis_num: data.enatis_num,
                        date_license_expiry: this.datePipe.transform(
                            data.Date_license_expiry,
                            'dd/MM/yyyy'
                        ),
                        seating_capacity: data.Seating_capacity,
                    });
                    this.isVehicleLoading = false;
                    this.isSouthAfrica = true;
                }
                else{

                    this.isVehicleLoading = false;
                    this.enable();
                    this.eNatisResult = null;
                    this.resetFormNotFound();
                    return this.toastService.error(
                            'Vehicle not found on eNatis database. Please add details manually',
                            'Vehicle'
                        );

                }
            });

        //             if (data.roadworthystatus != 'Roadworthy') {
        //                 return this.toastService.error(
        //                     'Please note that according to eNatis this vehicle is not roadworthy and therefore will not be eligible for permit application.',
        //                     'Vehicle'
        //                 );
        //             } else {
        //                 return this.toastService.success(
        //                     'Vehicle data found successfully on eNatis database. Please continue...',
        //                     'Vehicle'
        //                 );
        //             }
        //         }

        //         if (data.NotFound === 'Not found') {
        //             if (this.eNatisCounter <= 3) {
        //                 this.eNatisUpdate();
        //                 return;
        //             }
        //             this.toastService.error(
        //                 'Wasn\'t able to retrieve vehicle detail from eNatis - Please confirm VIN number is correct or try again later.\nAlternatively please enter the vehicle details manually.',
        //                 'Vehicle'
        //             );
        //             this.isVehicleLoading = false;
        //             this.eNatisResult = null;
        //             this.enable();
        //             if (this.isEditData == true) {
        //                 this.isSouthAfrica = true;
        //                 this.disallowEdit = true;
        //             }
        //             return;
        //         } else {
        //             this.eNatisCounter = 0;
        //         }

        //         if (data.NetworkError === 'Network error') {
        //             this.toastService.error(
        //                 'The system is offline at the moment, please try again later or You can add Vehicle details Manually',
        //                 'Error'
        //             );
        //             this.isVehicleLoading = false;
        //             this.enable();
        //             this.isSouthAfrica = false;
        //             this.disallowEdit = false;
        //             this.eNatisResult = null;
        //             return;
        //         }
        //     });

        }
        catch (error) {
            this.toastService.error(error, 'Vehicle');
            this.myForm.reset();
            return;
        }
    }

    getPermitsAppVecleEntry(id) {
        this.vehicleService.getPermitsAppVecleEntry(id).subscribe((data: any) => {
            //console.log(data);
            this.myAppVehicles = data;
        });
    }

    getCarrierPermitsAppVecleEntry(id, appid) {
        this.vehicleService
            .getCarrierPermitsAppVecleEntry(id, appid)
            .subscribe((data: any) => {
                //console.log(data);
                this.vehicleRes = data;
                this.count = data.length;
                if (this.count == 0) {
                    this.isEmpty = true;
                } else {
                    this.isEmpty = false;
                    this.utility.checkNoOfVehicles = 1;
                }
                this.isLoading = false;
                this.isMyVehicles = true;
            });
    }

    getCarrierPermitsAppVecleEntryPaginated(id, appid ,page,pageNumber) {
        this.isLoading = true;
        this.vehicleService
            .getCarrierPermitsAppVecleEntryPaginated(id, appid,page, pageNumber)
            .subscribe((data: any) => {
                //console.log('Data count ' +data.m_Item2);

                if (data.m_Item1 && data.m_Item2 > 0) {
                    this.vehicleRes = data.m_Item1;
                    this.count = data.m_Item2;
                    if(this.count > 0) 
                    {
                    this.isEmpty = false;
                    this.utility.checkNoOfVehicles = 1;
                    }
                  } else if (data.m_Item2 == 0) {
                    this.isEmpty = true;
                  }
                 // console.log('Pagination count ' +this.count);

                // this.vehicleRes = data;
                // this.count = data.length;
                // if (this.count == 0) {
                //     this.isEmpty = true;
                // } else {
                //     this.isEmpty = false;
                //     this.utility.checkNoOfVehicles = 1;
                // }
                this.isLoading = false;
                this.isMyVehicles = true;
            });
    }

    checkVehicle(event, item, res) {
        if (event.currentTarget.checked && this.isPermitApplication) {
            // this.selectedVehicle = true;
            this.selectedVehicle = res;
            this.vehicleService
                .isVehicleAttachedToPermit(item.id, this.carrierId)
                .subscribe((result) => {
                    if (result == true) {
                        return this.toastService.error(
                            'This vehicle is already in a permit',
                            'Vehicle'
                        );
                    }
                });
            this.getVehicleTypeForM(item);
        }
        if (event.currentTarget.checked && !this.isPermitApplication) {
            // this.selectedVehicle = true;
            this.selectedVehicle = res;
        }
        if (!event.currentTarget.checked) {
            const index: number = this.selectedVehicles.indexOf(item);
            if (index !== -1) {
                this.selectedVehicles.splice(index, 1);
            }
        }
    }

    addSelectedVehicles() {
        this.vehiclesReplacement = JSON.parse(
            localStorage.getItem('replacements') || '[]'
        );
        if (this.vehiclesReplacement.length > 0) {
            //console.log(this.selectedVehicles);
            //console.log(this.vehiclesReplacement);
            // let result = this.vehiclesReplacement.filter(o1 => this.selectedVehicles.some(o2 => o1.vin === o2.vin));
            // if (result.length > 0) {
            //   for (let i = 0; i < result.length; i++) {
            //     return this.toastr.warning('You cannot replace ' + result[i].registration_number + '. It is on the application already.')
            //   }
            // }
        }

        let checkVehicles = JSON.parse(
            localStorage.getItem('checkVehicle') || '[]'
        );

        if (checkVehicles.length > 0) {
             let result = checkVehicles?.filter((o1) =>
                this.selectedVehicles.some((o2) => o1.vin === o2.VehicleEntry.vin)
            );
            if (result.length > 0) {
                for (let i = 0; i < result.length; i++) {
                     this.toastService.success(
                        'You will need to add a different start date ' +
                        result[i].registration_number +
                        '. It is on the application already.',
                        'Vehicle'
                    ); 
                }
            } 
        }

        this.isLoading = true;
        this.message = 'Updating your vehicles. Please wait...';
        if (this.isReplacement === false) {
            console.log('calling check vehicles service the vehicles ' ,this.selectedVehicles );
            console.log('the application id ',this.appid  );
            this.vehicleEntryService
                .checkVehicles(this.selectedVehicles, this.appid)
                .subscribe((data: any) => {
                    let a = data.indexOf('Cannot add a vehicle with expired license to permit');
                    let b = data.indexOf('There is an active Permit for vehicle ');
                    
                    if (a !== -1) {
                      this.isLoading = false;
                      return this.toastService.error(data, 'Vehicle');
                    } else if (b !== -1) {
                      this.isLoading = false;
                      return this.toastService.error(data , 'Vehicle');
                    }
                    
                     else{
                        
                    /* this.router.navigate([
                        '/carrier/permit/application/edit/' + this.appid + '/' + true,
                    ]); */

                    this.router.navigate(['/carrier/permit/application/edit', this.appid,4,2]);
                    //console.log(data);
                    this.isLoading = false;
                }
                }, (error) => {
                    this.isLoading = false;
                    this.toastService.error(
                        'Failed to add vehicle to application.',
                        'Vehicle'
                    );
                });
        } else {
            this.vehicleEntryService
                .replaceVehicles(this.selectedVehicles, this.appid)
                .subscribe(
                    (data) => {
                        this.router.navigate([
                            '/carrier/permit/application/change/' +
                            this.appid +
                            '/vehicle/selected-vehicle',
                        ]);
                        //console.log(data);
                        this.isLoading = false;
                    },
                    (error) => {
                        this.isLoading = false;
                        this.toastService.error(
                            'Please make sure that, there is a vehicle to be replaced.',
                            'Vehicle'
                        );
                    }
                );
        }
    }

    getApp(id) {
        this.isLoading = true;
        if (id) {
            this.applicationService.getById(id).subscribe((data: any) => {
                //console.log(data);
                this.ctrlData = data;
                this.currentVehicle = data.vehicle > 0 ? data.vehicle[0] : null;
                this.curr_permit_type_id = data.permit_type_id;
                this.permit_type_id = data.permit_type_id;

                if (
                    data.permit_type.freight_passenger_ind != null &&
                    data.permit_type.freight_passenger_ind != undefined
                ) {
                    this.freight_passenger_ind = data.permit_type.freight_passenger_ind;
                }
                if (
                    data.permit_type.freight_passenger_ind != null &&
                    data.permit_type.freight_passenger_ind != undefined
                ) {
                    this.freight_passenger_ind = data.permit_type.freight_passenger_ind;
                }

                if(data?.carrier_id){
                    this.carrierId = data.carrier_id;
                    console.log('Carrier Id', this.carrierId);
                }

                this.listDepot();
                this.getVehicleType(data.permit_type_id);
                
                //this.getCarrierPermitsAppVecleEntryPaginated(data.carrier_id, id ,this.pageSize, 1);
                this.onCarrierSearch(1,this.pageSize);
            });
        } else {
            //need to find out the list of carriers linked to the user logged in
            console.log("am i here?");
            this.listDepot();
            this.onCarrierSearch(1,this.pageSize);
            this.isVehicleLoading = false;
            this.isLoading = false;
        }
    }

    onBack() {
        if (this.appid == undefined) {
            this.router.navigate(['/home']);
        }
        else{
                if (localStorage.getItem('replaceFlag') == 'true') {
                    let url: any = `carrier/permit/application/change/${this.appid}/vehicle`;
                    this.router.navigate([url]);
                }
                else {
                    this.router.navigate([
                        '/carrier/permit/application/edit/' + this.appid + '/' + true,
                    ]);
                }
            }
    }

    getVehicles() {
        if (this.appid === null || this.appid === undefined) {
            this.isLoading = true;
           // this.onSearch();
            // this.vehicleEntryService.getVehicles().subscribe((res: any) => {
            //   this.vehicleRes = res.Items;
            //   this.isLoading = false;
            //   this.count = res.Count;
            //   if (res.Items.length == 0) {
            //     this.isEmpty = true;
            //
            //   }
            // });
        } else {

            ///Not sure what to do with the else;;;TO DO
            this.isLoading = true;
           // this.onSearch();
        }
    }

    //Populate the Permit Types Search dropdown
    getPermitTypes() {
        this.permitTypeService.get().subscribe((result) => {
            //console.log('list of permit types', result);
            // this.vehicletypes = result.map(row => {
            //   return { id: row.id, desc: row.description };
            // });
            this.permittypes = result;
        });
    }

    //Populate the Vehicle Types Search dropdown
    loadvehicletypes = () => {
        this.vehicleTypeService.loadvehicletypes().subscribe((result) => {
            this.vehicletypes = result;
            //Only take the correct vehicles for the chosen permit type
        });
    };

    InitMultiselect() {
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'id',
            textField: 'desc',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 1000,
            allowSearchFilter: this.ShowFilter,
            maxHeight: 120,
            closeDropDownOnSelection: false,
        };
    }

    onItemSelect(item: any) {
        //console.log('onItemSelect', item);
        //console.log('selectedItems', this.selectedItems);
    }

    onSelectAll(items: any) {
        //console.log('onSelectAll', items);
    }

    onDeSelect(item: any) {
        //console.log('onItemSelect', item);
        //console.log('selectedItems', this.selectedItems);
    }

    onReset = () => {
        
        this.isReset = true;
        
        this.message = 'Loading vehicles, please wait...';
        this.isLoading = true;
        this.vehicleType = null;
        this.vinnumber =  null;
        this.regnumber =  null;
        this.initKeyword();
        this.VehicleSearch();
        this.selectedVehicle = null;
        
       // this.getApp(this.appid);
       // document.getElementById('btnSearch').click();
        this.isReset = false;
        this.IsSearching = false;
    };

    setSearchKeywords = () => {
    };

    initKeyword = () => {
    this.vehicleType = null;
    this.vinnumber =  null;
    this.regnumber =  null;
    };
    VehicleSearch()
    {
        if (!this.isMyVehicles) {
            this.onSearch(this.utility.page, this.pageSize);
        } else {
            this.onCarrierSearch(this.utility.page, this.pageSize);
        }
    }

    getCarrierPermitsAppVecleEntryPaginatedV2(object :any)
    {
        this.isLoading = true;
        console.log('paramters ', object);
        this.vehicleService.getCarrierPermitsAppVecleEntryPaginatedV2(object)
        .subscribe((data: any) => {
            //console.log('Data count ' +data.m_Item2);

            if (data.m_Item1 && data.m_Item2 > 0) {
                this.vehicleRes = data.m_Item1;
                this.count = data.m_Item2;
                if(this.count > 0) 
                {
                this.isEmpty = false;
                this.utility.checkNoOfVehicles = 1;
                }
              } else if (data.m_Item2 == 0) {
                this.isEmpty = true;
              }
             // console.log('Pagination count ' +this.count);

            // this.vehicleRes = data;
            // this.count = data.length;
            // if (this.count == 0) {
            //     this.isEmpty = true;
            // } else {
            //     this.isEmpty = false;
            //     this.utility.checkNoOfVehicles = 1;
            // }
            this.isLoading = false;
            this.isMyVehicles = true;
        });

    }
    onCarrierSearch = (page: number = 1, pageSize: number = 10) => {
        this.IsSearching = true;
        this.IsAdmin = false;
        this.utility.page = page;
        this.isLoading = true;
        this.vehicleRes = [];
        this.message = 'Searching your vehicles, please wait...';
        if (this.isReset)
        {
            console.log('its a reset')
            this.vehicleType = null;
            this.vinnumber =  null;
            this.regnumber =  null;
        }
        else
        {
            this.filter.getData().subscribe(data => {
                this.vehicleType = data.vehicleType ? data.vehicleType : '';
                this.vinnumber = data.vinNumber ? data.vinNumber : '';
                this.regnumber = data.regnumber ? data.regnumber : '';

                console.log('regnumber ', data.regnumber);
            });
        }
        


        if (this.vehicleType === '') {
            this.vehicleType = null;
        }

        if (this.vinnumber === '') {
            this.vinnumber = null;
        }

        if (this.regnumber === '') {
            this.regnumber = null;
        }

        if (this.carriername === '') {
            this.carriername = null;
        }

        if (this.carriercode === '') {
            this.carriercode = null;
        }
//get user logged in and linked Carriers
// note  user_id associated is a foreign key in person table
// a zero value for user_id implies a carrier_id has been supplied
        let object = {
            VehicleType: this.vehicleType,
            PermitType: this.permitType,
            VIN: this.vinnumber,
            Regnumber: this.regnumber,
            Carriername: this.carriername,
            Carrier_Id: ( typeof this.carrierId === 'undefined' || this.carrierId == null ) ? 0 : this.carrierId,
            Carriercode: this.carriercode,
            PageSize: pageSize,
            PageNumber: page,
            user_id: ( typeof this.carrierId === 'undefined' || this.carrierId == null ) ? this.storageService.getID() : 0
        };
        if (this.isReset){
            console.log('parameters ')
            console.log(object)
        }    
        
        
        this.getCarrierPermitsAppVecleEntryPaginatedV2(object);
       // this.getCarrierPermitsAppVecleEntryPaginated(this.carrierId, this.appid ,pageSize, this.utility.page);
        /* this.vehicleEntryService.searchCarrierVehicle(object).subscribe(
            (result: any) => {
                if (result == null) {
                    this.vehicleRes = [];
                    this.isEmpty = true;
                    this.isLoading = false;
                    return;
                }

                if (result.m_Item1 && result.m_Item2 > 0) {
                    this.vehicleRes = result.m_Item1;
                    this.count = result.m_Item2;
                    if(this.count > 0) this.isEmpty = false;
                  } else if (result.m_Item2 == 0) {
                    this.isEmpty = true;
                  }

                //this.vehicleRes = result;

                this.isLoading = false;
                // this.count = result.length;
                // if (result.length == 0) {
                //     this.isEmpty = true;
                // }
            },
            (error) => {
                this.isLoading = false;
            }
        ); */
    };

    onChange = () => {
        console.log('we are changing the page size');
        console.log('page ',this.utility.page);
        console.log('pageSize ',this.pageSize);
        if (this.IsAdmin) {
            this.onSearch((this.utility.page = 1), this.pageSize);
        } else {
            
            this.onCarrierSearch((this.utility.page = 1), this.pageSize);
        }
    };

    onSearch = (page: number = 1, pageSize: number = 10) => {
        this.IsSearching = true;
        this.isLoading = true;
        this.message = 'Searching vehicles, please wait...';

        if (!this.isExternalRole) {
            this.carriercode = null;
            this.carrierId = null;
        }

        if (this.isReset)
        {
                this.vehicleType =  '';
                this.vinnumber =  '';
                this.regnumber =  '';
        }
        else
        {
           this.filter.getData().subscribe(data => {
               this.vehicleType = data.vehicleType ? data.vehicleType : '';
               this.vinnumber = data.vinNumber ? data.vinNumber : '';
               this.regnumber = data.regnumber ? data.regnumber : '';
           });
        }

        if (this.vehicleType === '') {
            this.vehicleType = null;
        }

        if (this.vinnumber === '') {
            this.vinnumber = null;
        }

        if (this.regnumber === '') {
            this.regnumber = null;
        }

        if (this.carriername === '') {
            this.carriername = null;
        }

        if (this.carriercode === '') {
            this.carriercode = null;
        }

        let object = {
            VehicleType: this.vehicleType,
            PermitType: this.permitType,
            VIN: this.vinnumber,
            Regnumber: this.regnumber,
            Carriername: this.carriername,
            carriercode: this.carriercode,
            CarrierId: this.carrierId,
            PageSize: pageSize,
            PageNumber: page,
        };

        console.log('Vehicle', object);

        this.vehicleEntryService.searchVehicleV2(object).subscribe(
            (result: any) => {
                if (result == null) {
                    this.vehicleRes = [];
                    this.isLoading = false;
                    return;
                }

                this.vehicleRes = result.Items;
                console.log('Search Result: ' + JSON.stringify(this.vehicleRes));
                this.isLoading = false;
                this.count = result.Count;
                
                this.utility.onSort(1);
                if (result.Items.length == 0) {
                    this.isEmpty = true;
                } else {
                    this.isEmpty = false;
                    this.utility.checkNoOfVehicles = 1;
                }
            },
            (error) => {
                this.isLoading = false;
            }
        );
    };

    onNextOrPrevious(page: number=1) {
        if (this.IsAdmin) {
            this.onSearch(page, this.pageSize);
        } else {
            this.onCarrierSearch(page, this.pageSize);
        }

        this.currentPage = page;
        return page;
    }

    listCountries() {
        this.countryService.listCountries().subscribe(
            (result) => {
                this.ddlCountries = result;
                //console.log(result);
            },
            (error) => {
                //console.log(error);
            }
        );
    }

    listDepot() {

        this.carrierDepotService.getDepotByCarrier(this.carrierId).subscribe(
            (result) => {
                this.ddlDepots = result;
                //console.log(result);
            },
            (error) => {
                //console.log(error);
            }
        );

    }

    getVehicleMake() {
        if (this.list_vehicle_make.length <= 0) {
            this.vehicleMakeService.getAll().subscribe(
                (result: any) => {
                    this.list_vehicle_make = result;
                    //console.log(this.list_vehicle_make);
                    this.selectedVMake = result.find((x) => x.code == 'Unknown');
                    //console.log(this.list_vehicle_make)
                },
                (error) => {
                    //console.log(error);
                }
            );
        }
    }

    getVehicleType(id) {
        this.vehicleTypeService.getPermitTypeVehicles().subscribe(
            (result: any) => {
                this.list_vehicle_type = result?.filter((x) => x.permit_type_id === id);
                //console.log(this.list_vehicle_type)
                if (this.list_vehicle_type.length > 0) {
                    this.btnAddNew = true;
                }
                //console.log(this.btnAddNew)
                //console.log(this.list_vehicle_type.length)
            },
            (error) => {
                //console.log(error);
            }
        );
    }

    getVehicleTypeForM(item) {
        this.isLoading = true;
        this.message = 'Checking vehicle...';
        //console.log(item);
        this.vehicleTypeService.getPermitTypeVehicles().subscribe(
            (result: any) => {
                console.log('Selected Permit Type: ' + this.permit_type_id);
                this.list_vehicle_types = result?.filter(
                    (x) => x.permit_type_id === this.permit_type_id
                );
                console.log(this.list_vehicle_type.length);
                console.log(this.list_vehicle_types);
                if (this.list_vehicle_type.length == 0) {
                    this.isLoading = false;
                    this.toastService.error(
                        'No vehicle types have been linked to this permit type. Please update the Corporate Reference Data link..',
                        'SYSTEM CONFIG'
                    );
                    return;
                }
                let ptId = this.list_vehicle_types[0].permit_type_id;
                let permitDescRecord: any = this.permittypes.find((p) => p.id == ptId);
                let permitDesc = permitDescRecord.description.toUpperCase();
                console.log('Selected vehicle type: ' + item.vehicle_type_id);
                let check = this.list_vehicle_types.find(
                    (x) => x.vehicle_type_id === item.vehicle_type_id
                );
                console.log(check);
                console.log(
                    this.list_vehicle_types.find(
                        (x) => x.vehicle_type_id === item.vehicle_type_id
                    )
                );
                if (check !== undefined) {
                    if (
                        item.VehicleEntry.is_leased == true &&
                        (permitDesc.search('TAXI') != -1 ||
                            permitDesc.search('ORGANISED GROUP') != -1 ||
                            permitDesc.search('ORGANIZED GROUP') != -1)
                    ) {
                        this.toastService.error(
                            'This permit type is not issued for leased vehicles.',
                            'Vehicle'
                        );
                    } else if (this.isReplacement) {
                        this.checkVehicleClass(item);
                        if (this.wrongClass) {
                            this.toastService.error(this.classMessage, 'Replace Vehicle');
                        } else {
                            console.log(this.isReplacement);
                            this.selectedVehicles.push(item);
                        }
                    } else {
                        console.log(this.isReplacement);
                        //console.log(this.isReplacement)
                        //console.log(this.wrongClass)
                        //this.selectedVehicles.push(item);
                        //console.log(this.selectedVehicles);
                        if (this.freight_passenger_ind == 1) {    
                            var pitem = this.permittypes.find(x => x.id == this.curr_permit_type_id);   
                            var item_gvm = item.VehicleEntry!=null ? item.VehicleEntry.gvn : item.gvn;   
                                if (pitem.max_gvm < 20001) {
                                  
                                    if (Number(item_gvm) > 20000) {
                                       this.toastr.warning(
                                            'Vehicle class does not match the permit class. Please choose an appropriate vehicle',
                                            'Gross Vehicle(GVM)'
                                        );
                                        setTimeout(() => {
                                          this.toastr.clear();
                                          clearTimeout();
                                        }, 25000);
                                    }
                                    else
                                    {
                                      this.selectedVehicles.push(item);
                                    }
                                } else {
                                    if (Number(item_gvm) < 20001) {
                                        this.toastr.warning(
                                            'Vehicle class does not match the permit class. Please choose an appropriate vehicle',
                                            'Gross Vehicle(GVM)'
                                        );
                                        setTimeout(() => {
                                          this.toastr.clear();
                                          clearTimeout();
                                        }, 25000);
                                    }
                                    else
                                    { 
                                        
                                      this.selectedVehicles.push(item);
                                    }
                                }
                            }
                            else{
                              this.selectedVehicles.push(item);
                            }
                        
                    }
                }
                if (check === undefined) {
                    this.toastService.error(
                        'Please select a suitable vehicle type for the type of permit on your application.',
                        'Vehicle Selection'
                    );
                }
                this.isLoading = false;
            },
            (error) => {
                //console.log(error);
                // this.isLoading = false;
            }
        );
    }

    getVehiclesReplacement() {
        this.vehicleService.getAllVehicles().subscribe((data) => {
            this.vehiclesReplacement = data;
        });
    }

    editVehicle(item) {
        this.isVehicleLoading = true;
        this.eNatisResult = null;
        $('.action').val('null');
        this.vehicleEntryService
            .getVehicleDeatilsById(item.id)
            .subscribe((x: any) => {
                // this.vehicleEntryService.getVehicleEntryById(item.id).subscribe(x=>{
                //console.log(x);
                if (x != null) {
                    //console.log("enatis_num: " + x.VehicleEntry.vehicle_register_num);
                    // //console.log("vehicle_lessor " + x.VehicleEntry.vehicle_lessor);
                    // //console.log("vehicle_lessee " + x.VehicleEntry.vehicle_lessee);
                    this.leased = x.VehicleEntry.is_leased;

                    if (x.VehicleEntry.country_id == 113) {
                        this.isSouthAfrica = true;
                    } else {
                        this.isSouthAfrica = false;
                    }

                    // this.isEditData = true;

                    this.myForm.patchValue({
                        id: x.VehicleEntry.id,
                        date_license_expiry: this.datePipe.transform(
                            x.VehicleEntry.date_license_expiry,
                            'dd/MM/yyyy'
                        ),
                        gvn: x.VehicleEntry.gvn,
                        registration_number: x.VehicleEntry.registration_number,
                        registration_year: x.VehicleEntry.registration_year,
                        depot_id: x.depot_id,
                        seating_capacity: x.VehicleEntry.seating_capacity,
                        start_date: this.datePipe.transform(x.start_date, 'dd/MM/yyyy'),
                        vehicle_make_id: x.VehicleEntry.vehicle_make_id,
                        vehicle_type_id: x.VehicleEntry.vehicle_type_id,
                        vin: x.VehicleEntry.vin,
                        permit_id: x.permit_id,
                        country_id: x.VehicleEntry.country_id,
                        vehicle_series: x.VehicleEntry.vehicle_series,
                        vehicle_model: x.VehicleEntry.vehicle_model,
                        vehicle_colour: x.VehicleEntry.vehicle_colour,
                        engine_number: x.VehicleEntry.engine_number,
                        eNatis_num: x.VehicleEntry.vehicle_register_num,
                        vehicle_state: x.vehicle_state,
                        roadworthy_status: x.VehicleEntry.roadworthy_status,
                        vehicle_owner: x.VehicleEntry.vehicle_owner,
                        is_leased: x.VehicleEntry.is_leased,
                        vehicle_lessor: x.VehicleEntry.vehicle_lessor,
                        vehicle_lessee: x.VehicleEntry.vehicle_lessee,
                        date_lease_expiry: this.datePipe.transform(
                            x.VehicleEntry.date_lease_expiry,
                            'dd/MM/yyyy'
                        ),
                    });
                    var cId = x.VehicleEntry.country_id;
                   // console.log(this.ddlCountries.find(x => x.id == cId))
                    this.selectedCountry = this.ddlCountries.find(x => x.id == cId).desc;
                    this.LeaseChange(event);

                    if (x.country_id === 113) {
                        this.isSouthAfrica = true;
                        this.disallowEdit = true;
                    }

                    // this.eNatisForUpdate();
                    document.getElementById('myButton').click();

                    // $("#addEdit").modal('show');
                }
                this.isVehicleLoading = false;
            });
    }

    SaveModal() {
        console.log('GVMS', this.vehicleGVMs);
        console.log('AllctrlData', this.ctrlData);

        const selectedId = this.mySelectedCountry.nativeElement.value;
        this.myForm.value.country_id = selectedId;

        let CurrentYear = new Date().getFullYear();

        this.myForm.value.vehicle_make_id = this.selectedVMake.id;
        // if (!this.myForm.value.country_id) {
        //   return this.toastService.error('Country of vehicle registration is required!', 'Country Of Vehicle Registration');
        // }
        if (!this.myForm.value.registration_number) {
            return this.toastService.error(
                'Vehicle registration number is required!',
                'Vehicle Registration Number'
            );
        }
        // if(!this.myForm.value.vehicle_make_id){
        //   return this.toastr.warning('Vehicle make is required!','Vehicle Make');
        // }
        if (!this.myForm.value.vin) {
            return this.toastService.error(
                'VIN or Chassis number is required!',
                'VIN or Chassis Number'
            );
        }
        // if(this.myForm.value.vin.length !== 17){
        //   return this.toastr.warning('VIN should be 17 alphanumeric characters.','VIN or Chassis Number')
        // }
        if (!this.myForm.value.engine_number) {
            return this.toastService.error(
                'Engine number is required!',
                'Engine Number'
            );
        }
        if (!this.myForm.value.gvn) {
            return this.toastService.error(
                'Gross Vehicle(GVM) is required!',
                'Gross Vehicle(GVM)'
            );
        }
        if (this.freight_passenger_ind == 1) {
            //Check gvm exists in DB and is greater than zero
            var idExists = this.checkIfIdExists(this.ctrlData.permit_type_id);
            if (idExists) {
                var item = this.vehicleGVMs.find(
                    (item) => item.id === this.ctrlData?.permit_type_id
                );

                if (item.max_gvm < 20001) {
                    if (Number(this.myForm.value.gvn) > 20000) {
                        return this.toastService.error(
                            'Vehicle class does not match the permit class. Please choose an appropriate vehicle',
                            'Gross Vehicle(GVM)'
                        );
                    }
                } else {
                    if (Number(this.myForm.value.gvn) < 20001) {
                        return this.toastService.error(
                            'Vehicle class does not match the permit class. Please choose an appropriate vehicle',
                            'Gross Vehicle(GVM)'
                        );
                    }
                }
            }
        }
        if (!this.myForm.value.date_license_expiry) {
            return this.toastService.error(
                'License expiry date is required!',
                'License Expiry Date'
            );
        }
        // if(!this.myForm.value.start_date){
        //   return this.toastr.warning('Start Date is required!','Permit Start Date');
        // }
        if (!this.myForm.value.roadworthy_status) {
            return this.toastService.error(
                'Roadworthy status is required!',
                'Roadworthy Status'
            );
        }
        if (this.myForm.value.roadworthy_status != 'Roadworthy') {
            return this.toastService.error(
                'Vehicle is not Roadworthy',
                'Roadworthy Status'
            );
        }
        if (!this.myForm.value.vehicle_type_id) {
            return this.toastService.error(
                'Vehicle type is required!',
                'Vehicle Type'
            );
        }

        const expiryDate = new Date(this.myForm.value.date_license_expiry);
        const today = this.datePipe.transform(new Date(), 'dd/mm/yyyy', 'en-US');
        // this.expiryDate = this.datePipe.transform(this.expiryDate, 'dd/mm/yyyy');

        //console.log(expiryDate);
        //console.log(this.myForm.value.date_license_expiry);
        //console.log(today);

        // if (!(this.myForm.value.date_license_expiry >= today) ) {
        //   return this.toastr.warning('License has Expirered, Please renew your licence', 'License Expiry Date');
        // }
        // if(!this.myForm.value.vehicle_owner){
        //   return this.toastr.warning('Vehicle owner name is required!','Vehicle Owner Name');
        // }
        if (this.myForm.value.is_leased === null) {
            return this.toastService.error('Is the vehicle leased?', 'Vehicle');
        }
        if (this.leased === true || this.leased === 'true') {
            //console.log('inside')
            if (!this.myForm.value.vehicle_lessor) {
                return this.toastService.error(
                    'Lessor name is required!',
                    'Lessor Name'
                );
            }
            if (!this.myForm.value.vehicle_lessee) {
                return this.toastService.error(
                    'Lessee name is required!',
                    'Lessee Name'
                );
            }
            if (!this.myForm.value.date_lease_expiry) {
                return this.toastService.error(
                    'Expiry date of lease is required!',
                    'Expiry Date Of Lease'
                );
            }
        }
        if (
            !(
                parseInt(this.myForm.value.registration_year) >= 1950 &&
                parseInt(this.myForm.value.registration_year) <= 2100
            )
        ) {
            this.toastService.error('Invalid Registration Year', 'Error');
            return false;
        }
        if (parseInt(this.myForm.value.registration_year) > CurrentYear) {
            return this.toastService.error(
                'Registration year is greater than current year!',
                'Registration Year'
            );
        }

        if (this.leased === false || this.leased === 'false') {
            this.myForm.value.vehicle_lessor = '';
            this.myForm.value.vehicle_lessee = '';
            this.myForm.value.date_lease_expiry = '';
        }
        //console.log(this.myForm.value.is_leased);

        if (
            this.myForm.value.date_license_expiry &&
            this.myForm.value.date_license_expiry.includes('/')
        ) {
            let date_license_expiry = this.myForm.value.date_license_expiry;
            let date = date_license_expiry.split('/');
            let day = parseInt(date[0], 10);
            let month = parseInt(date[1], 10);
            let year = parseInt(date[2], 10);
            let newDate = year + '/' + month + '/' + day;
            let newDate1 = new Date(newDate);
            newDate1.setDate(newDate1.getDate() + 1);
            this.myForm.value.date_license_expiry = newDate1;
        }

        if (
            this.myForm.value.date_lease_expiry &&
            this.myForm.value.date_lease_expiry.includes('/')
        ) {
            let date_lease_expiry = this.myForm.value.date_lease_expiry;
            let date1 = date_lease_expiry.split('/');
            let day1 = parseInt(date1[0], 10);
            let month1 = parseInt(date1[1], 10);
            let year1 = parseInt(date1[2], 10);
            let newDate2 = year1 + '/' + month1 + '/' + day1;
            let newDate11 = new Date(newDate2);
            newDate11.setDate(newDate11.getDate() + 1);
            this.myForm.value.date_lease_expiry = newDate11;
        }

        // if(this.myForm.value.start_date){
        //   let  start_date = this.myForm.value.start_date;
        //   let date20 = start_date.split('/');
        //   let  day20 = parseInt(date20[0], 10);
        //   let  month20 = parseInt(date20[1], 10);
        //   let  year20 = parseInt(date20[2], 10);
        //   let newDate20 = year20 + '/'+ month20 + '/' + day20;
        //   let newDate110 = new  Date (newDate20);
        //   newDate110.setDate(newDate110.getDate() + 1);
        //   this.myForm.value.start_date = newDate110;
        //   this.myForm.value.api_date_updated = this.myForm.value.start_date
        // }

        (this.myForm.value.date_modified = new Date()),
            (this.myForm.value.date_created = new Date()),
            (this.myForm.value.user_modified = this.myForm.value.user_created =
                environment.authWebApi.userData.User.FirstName),
            (this.myForm.value.vehicle_register_num = this.myForm.value.eNatis_num);
        //console.log(this.myForm.value);
        this.isVehicleLoading = true;
        //this.dataCntrl.permit.date_11 = this.myForm.value.start_date;
        // if(this.selectedCountry.code=='ZA'){
        //   //console.log('default country');

        // }
        // else{
        //   //console.log('other country');
        // }

        //if(res.registration_number==this.myForm.value.registration_number){
        if (this.myForm.value.id == -1) {
            this.vehicleEntryService
                .postVehicleEntry(
                    this.myForm.value,
                    this.ctrlData?.carrier_id ?? this.carrierId,
                    this.myForm.value.depot_id
                )
                .subscribe(
                    (itemRes: any) => {
                    //    this.onSearch();
                        if (itemRes.Result.includes('Updated')) {
                            this.toastService.error(
                                'Vehicle details already exists for this carrier. Updated details successfully.',
                                'Vehicle already in register'
                            );
                            var vehicleId = itemRes.Result.substring(
                                itemRes.Result.indexOf('-') + 1
                            );
                            this.postVehicleFiles(vehicleId);
                        } else if (itemRes.Result == 'AlreadyInPermit') {
                            this.toastService.error(
                                'Vehicle details already exists in active Permit.',
                                'Vehicle already in active Permit'
                            );
                        } else {
                            this.toastService.success('Saved Vehicle Details', 'Vehicle');
                            var vehicleId = itemRes.Result.substring(
                                itemRes.Result.indexOf('-') + 1
                            );
                            this.utility.checkNoOfVehicles = 1;
                            this.postVehicleFiles(vehicleId);
                        }
                        //post documents

                        this.isVehicleLoading = true;
                        // $("#addEdit").modal('hide');`
                        document.getElementById('closeModal').click();
                        this.getApp(this.appid);
                        this.isVehicleLoading = false;
                        this.selectedVehicles = [];
                    },
                    (err) => {
                        this.isVehicleLoading = false;
                        this.toastService.error(
                            'Failed to save application. If the problem persist, please contact system administrator.',
                            'Save Application'
                        );
                    }
                );
        } else {
            this.vehicleEntryService
                .postVehicleEntry(
                    this.myForm.value,
                    this.ctrlData?.carrier_id ?? this.carrierId,
                    this.myForm.value.depot_id
                )
                .subscribe(
                    (itemRes) => {
                        this.toastService.success('Updated Vehicle Details', 'Vehicle');
                        // $("#addEdit").modal('hide');
                    //    this.onSearch();
                        document.getElementById('closeModal').click();
                        this.getApp(this.appid);
                        this.isVehicleLoading = false;
                    },
                    (err) => {
                        this.isVehicleLoading = false;
                        this.toastService.error(
                            'Failed to save application. If the problem persist, please contact system administrator.',
                            'Save Application'
                        );
                    }
                );
        }

        // }else{
        //   this.isLoading=false;
        //   this.toastr.warning('Registration numbe do not match');
        // }

        // this.permitService.postPermit(this.dataCntrl.permit).subscribe(result => {
        //   this.myForm.value.permit_id = result.id;
        //   this.vehicleService.updateVehicle(this.myForm.value).subscribe(x =>{
        //     setTimeout(()=>{this.getSavedVehicleByPermit('');},400);
        //     this.pageload = false;
        //     this.closebutton.nativeElement.click();
        //     this.toastr.success('Saved Vehicle Successfully','Vehicle');
        //   })
        // })
    }

    LeaseChange(event) {
        if (this.isEditData || this.isViewData) {
        } else {
            this.leased = this.myForm.value.is_leased;
        }

        if (this.leased == 'true' || this.leased == true) {
            this.myForm.get('vehicle_lessor').setValidators([Validators.required]);
            this.myForm.get('vehicle_lessee').setValidators([Validators.required]);
            this.myForm.get('date_lease_expiry').setValidators([Validators.required]);
            if (event.target.value) {
                this.documenttypeSerivce.getAll().subscribe((res: any) => {
                    //console.log(res);
                    this.uploadedDocs = [];
                    if (res != null && res.length > 0) {
                        this.uploadedDocs = res?.filter((map) => {
                            return map.is_for_vehicle == true;
                        });
                        this.uploadedDocs = this.uploadedDocs?.filter(
                           // (x) => x.description !== 'Travel Itinerary' && x.description !== 'SARS Tax Clearance Certificate ' && x.description !== 'South African ID'&& x.code !== 'SAID-PSS-NTS' && x.code !== 'SARS-STAT '
                           (x) => { return ((x.code !== 'SAID-PSS-NTS') && (x.code !== 'SARS-STAT ') && (x.code !== 'TRAV-ITIN') && (x.code !== 'MT-VH-LIC') ) }
                        );
                        this.getUploadDocs();
                    }
                });
            }
        } else {
            this.myForm.get('vehicle_lessor').clearValidators();
            this.myForm.get('vehicle_lessee').clearValidators();
            this.myForm.get('date_lease_expiry').clearValidators();
            console.log(event);
            if (event.target.value) {
                this.uploadedDocs = this.uploadedDocs?.filter(
                    (x) => x.description !== 'Lease Agreement'
                );
                this.uploadedDocs = this.uploadedDocs?.filter(
                    //(x) => x.description !== 'Travel Itinerary' && x.description !== 'SARS Tax Clearance Certificate ' && x.description !== 'South African ID'&& x.code !== 'SAID-PSS-NTS' && x.code !== 'SARS-STAT '
                    (x) => { return ((x.code !== 'SAID-PSS-NTS') && (x.code !== 'SARS-STAT ') && (x.code !== 'TRAV-ITIN') && (x.code !== 'MT-VH-LIC') && x.is_for_vehicle == true) }
                );
            }
        }

        this.myForm.get('vehicle_lessor').updateValueAndValidity();
        this.myForm.get('vehicle_lessee').updateValueAndValidity();
        this.myForm.get('date_lease_expiry').updateValueAndValidity();
    }

    numberOnly(event): boolean {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    selectCountry(countryCode) {
        let list: any = this.ddlCountries?.filter((map) => {
            return map.id == countryCode.value;
        });
        if (list != null && list.length > 0) {
            this.selectedCountry = list[0];
        }
    }

    checkRoadworthy(event: any) {
        if (event.target.value != 'Roadworthy') {
            if (this.myForm.value.country_id === 113) {
                this.toastService.error(
                    'Please note that according to eNatis this vehicle is not roadworthy and therefore will not be eligible for permit application.',
                    'Vehicle'
                );
            } else {
                this.toastService.error(
                    'Please note that according to your selection this vehicle is not roadworthy and therefore will not be eligible for permit application.',
                    'Vehicle'
                );
            }
            return;
        }
    }

    // checkCountrySelection (event: any) {
    //   if (!this.myForm.value.country_id) {
    //        this.toastr.info("Please select the vehicle's Country-of-Registration before continuing.")
    //    return
    //   }
    // }

    CloseModal() {
        // $("#addEdit").modal('hide');
        document.getElementById('closeModal').click();
        this.isEditData = false;
        this.disallowEdit = false;
        this.leased = false;
        this.isViewData = false;
        this.isSouthAfrica = false;
        this.isVehicleLoading = false;
        this.myForm.controls.country_id.enable();
        this.myForm.controls.roadworthy_status.enable();
        this.myForm.controls.vehicle_type_id.enable();
        this.myForm.controls.is_leased.enable();
        // this.myForm.controls.carrier_id.enable();
    }

    selectAction(actionType, res) {
        // if (actionType.value == 'edit') {
        //   this.editVehicle(res);
        // }
        if (actionType.value == 'view') {
            this.isViewData = true;
            this.isEditData = false;
            this.editVehicle(res);
            this.myForm.controls.country_id.disable();
            this.myForm.controls.roadworthy_status.disable();
            this.myForm.controls.vehicle_type_id.disable();
            this.myForm.controls.is_leased.disable();
            // this.myForm.controls.carrier_id.disable();
        } else if (actionType.value == 'edit') {
            this.isEditData = true;
            this.isViewData = false;
            this.editVehicle(res);
            this.myForm.controls.country_id.enable();
            this.myForm.controls.roadworthy_status.enable();
            this.myForm.controls.vehicle_type_id.enable();
            this.myForm.controls.is_leased.enable();
            // this.myForm.controls.carrier_id.enable();
        }
        if (actionType.value == 'delete') {
            this.OndeleteVehicle(res);
        }
        if (actionType.value == 'upload') {
            this.selectItem = res;
            this.uploadDocs(res);
        }
        return;
    }

    deleteVehicle(res) {
        this.OndeleteVehicle(res);
    }

    OndeleteVehicle(vehicle) {
        console.log('Selected vehicle', vehicle);
        if (!this.selectedVehicle) {
            this.toastService.error('Please select a vehicle first', 'Error');
            return;
        }
        if (vehicle?.Permit !== null && vehicle?.Permit.is_valid) {
            this.toastService.error('Cannot delete a valid permit', 'Error');
            return;
        }
        this.confirmDialogService.confirmThis(
            'Are you sure you want to delete this vehicle?',
            () => {
                let object = {
                    vehicle_entry: vehicle.VehicleEntry.id,
                    carrier_id: this.carrierId,
                    permit_id: vehicle.permit_id,
                };

                if (this.carrierId == '') {
                    this.toastService.success('Please filter by one carrier', 'Vehicle');
                    return;
                }
                this.isVehicleLoading = true;

                //console.log("vehicle object: " + JSON.stringify(vehicle));
                this.vehicleEntryService.deletevehicle(object).subscribe(
                    (result: any) => {
                        if (result != null) {
                            //console.log("Delete object: " + JSON.stringify(result));
                            this.toastService.success(
                                JSON.stringify(result.Value),
                                'Vehicle'
                            );
                           // this.onSearch();
                            this.getApp(this.appid);
                            this.isVehicleLoading = false;
                            return;
                        } else {
                            this.toastService.error(
                                'No vehicle entry record found',
                                'Vehicle'
                            );
                            this.isVehicleLoading = false;
                        }
                    },
                    (error) => {
                        this.isVehicleLoading = false;
                    }
                );
            },
            function () {
            }
        );
        // this.msgService.showYesNo('Delete Vehicle', `Are you sure you want to delete this vehicle`, '').subscribe(isConfirmed => {

        //   if (isConfirmed) {

        //     let object = {
        //       vehicle_entry: vehicle.VehicleEntry.id,
        //       carrier_id: this.carrierId,
        //       permit_id: vehicle.permit_id
        //     }

        //     if (this.carrierId == "") {
        //       this.toastr.success("Please filter by one carrier", 'Vehicle');
        //       return;
        //     }
        //     this.isVehicleLoading = true;

        //     //console.log("vehicle object: " + JSON.stringify(vehicle));
        //     this.vehicleEntryService.deletevehicle(object).subscribe((result:any) => {
        //       if (result != null) {
        //         //console.log("Delete object: " + JSON.stringify(result));
        //         this.toastr.success(JSON.stringify(result.Value), 'Vehicle');

        //         this.getApp(this.appid);
        //         this.isVehicleLoading = false;
        //         return;

        //       } else {
        //         this.toastr.warning('No vehicle entry record found', 'Vehicle');
        //         this.isVehicleLoading = false;
        //       }
        //     }, error => {
        //       this.isVehicleLoading = false;
        //     });

        //   }

        // })
    }

    uploadDocs(res) {
        if (res != null) {
            $('.action').val('null');

            // $("#uploadDocuments").modal('show');
            document.getElementById('btnShowUploadDocument').click();
            this.documenttypeSerivce.getAll().subscribe((res: any) => {
                //console.log(res);
                this.uploadedDocs = [];
                if (res != null && res.length > 0) {
                    this.uploadedDocs = res?.filter((x) => { return ((x.code !== 'SAID-PSS-NTS') && (x.code !== 'SARS-STAT ') && (x.code !== 'TRAV-ITIN') && (x.code !== 'MT-VH-LIC') && (x.is_for_vehicle == true)) });
                    this.getUploadDocs();
                }
                if (this.leased == false) {
                    this.uploadedDocs = this.uploadedDocs?.filter(
                        (x) => x.description !== 'Lease Agreement'
                    );
                }
            });
        }
    }

    onFileChange(pFileList: File[], documenttypeid) {
        let file: any = null;
        file = Object.keys(pFileList).map((key) => pFileList[key]);
        this.handleDropFileInput(file, documenttypeid);

        // this.toastr.info(`File uploaded successfully`, 'File Upload.');
    }

    logError(error) {
        console.error(error);
    }

    handleFileInput(event, id) {
        const reader = new FileReader();
        if (event.target.files && event.target.files.length > 0) {
            let file: any = null;
            const count = event.target.files.length;
            file = event.target.files[count - 1];
            let result = this.checkFileType(file.name);
            // item.document_type_id = this.docTypeData.id;
            // item.code = this.doctypesDesc.code
            // item.description=file.name;
            this.docTypeId = id;
            // this.uploadInfo.push(this.docTypeData);
            // localStorage.setItem('uploads',JSON.stringify(this.uploadInfo));
            const reader = new FileReader();

            if (event.target.files && event.target.files.length > 0) {
                let file: any = null;
                const count = event.target.files.length;

                file = event.target.files[count - 1];
                let result = this.checkFileType(file.name);

                //if File type is in not found
                if (result != -1) {
                    let sizeresult = this.checkFileSize(file.size);

                    if (sizeresult != -1) {
                        this.ref.detectChanges();

                        reader.removeEventListener;
                        reader.readAsDataURL(file);
                        reader.onload = () => {
                            this.filebytes = reader.result.toString().split(',')[1];
                            (this.filename = file.name), (this.filetype = file.type);
                            this.filedescription = 'upload';
                            this.filesize = file.size;
                            this.validateData(this.docTypeId);
                        };
                    } else {
                        // this.uploader.nativeElement.value = ''
                        let allowedFileSize =
                            environment.authWebApi.systemData.Configurations.find(
                                (p) => p.Code == 'MaxUploadMB1'
                            );
                        // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
                        this.toastService.error(
                            `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`,
                            'File Upload Failed, Please try again.'
                        );
                    }
                } else {
                    let allowedFileTypes =
                        environment.authWebApi.systemData.Configurations.find(
                            (p) => p.Code == 'UploadDocTypes1'
                        );
                    this.toastService.error(
                        `Only these file types are allowed: PDF`,
                        'File Upload Failed, Please try again.'
                    );
                }
            }
        }
    }

    handleTempFileInput(event, id) {
        console.log(id);
        const reader = new FileReader();

        if (event.target.files && event.target.files.length > 0) {
            let file: any = null;
            const count = event.target.files.length;
            file = event.target.files[count - 1];
            let result = this.checkFileType(file.name);
            // item.document_type_id = this.docTypeData.id;
            // item.code = this.doctypesDesc.code
            // item.description=file.name;
            this.docTypeId = id;

            const reader = new FileReader();

            if (event.target.files && event.target.files.length > 0) {
                let file: any = null;
                const count = event.target.files.length;

                file = event.target.files[count - 1];
                let result = this.checkFileType(file.name);

                //if File type is in not found
                if (result != -1) {
                    let sizeresult = this.checkFileSize(file.size);

                    if (sizeresult != -1) {
                        this.ref.detectChanges();

                        reader.removeEventListener;
                        reader.readAsDataURL(file);
                        reader.onload = () => {
                            this.filebytes = reader.result.toString().split(',')[1];
                            console.log(this.filebytes);
                            (this.filename = file.name), (this.filetype = file.type);
                            this.filedescription = 'upload';
                            this.filesize = file.size;
                            //this.validateData(this.docTypeId);

                            const formdata = new FormData();
                            formdata.append('File', this.filebytes);
                            formdata.append('file_name', this.filename);
                            formdata.append('TypeOfFile', this.filetype);
                            formdata.append('description', this.filedescription);
                            formdata.append('FileSize', this.filesize);
                            //formdata.append('vehicleEntryId', this.selectItem.VehicleEntry.id);
                            formdata.append('VehicleName', 'VehicalName - ' + this.filename);
                            formdata.append('UserLastName', this.user.LastName);
                            formdata.append('documenttypeid', this.docTypeId);
                            formdata.append('ApplicationId', this.appid);
                            formdata.append('shareId', this.appid);
                            formdata.append('CarrierId', this.carrierId);

                            this.DocumentsToUpload.push(formdata);

                            let docs: any = this.uploadedDocs?.filter((map) => {
                                return map.id == this.docTypeId;
                            });
                            //this.uploadedDocs = docs;
                            if (docs != null && docs.length > 0) {
                                const originalDoc = docs[0]; // Assuming docs contains only one item
                                const clonedDoc = { ...originalDoc }; // Create a shallow copy
                            
                                // Modify the properties of the cloned document
                                clonedDoc.file_name = this.filename;
                                clonedDoc.document_type_id = this.docTypeId;
                                clonedDoc.document_link = this.filebytes;
                            
                                // Push the cloned document into this.viewDocuments
                                this.viewDocuments.push(clonedDoc);
                            }
                            
                        };
                    } else {
                        // this.uploader.nativeElement.value = ''
                        let allowedFileSize =
                            environment.authWebApi.systemData.Configurations.find(
                                (p) => p.Code == 'MaxUploadMB1'
                            );
                        // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
                        this.toastService.error(
                            `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`,
                            'File Upload Failed, Please try again.'
                        );
                    }
                } else {
                    let allowedFileTypes =
                        environment.authWebApi.systemData.Configurations.find(
                            (p) => p.Code == 'UploadDocTypes1'
                        );
                    this.toastService.error(
                        `Only these file types are allowed: PDF`,
                        'File Upload Failed, Please try again.'
                    );
                }
            }
        }
    }

    checkFileType(fileName: string) {
        // from the file name derive the extension
        let allowedFileTypes =
            environment.authWebApi.systemData.Configurations.find(
                (p) => p.Code == 'UploadDocTypes1'
            );
        let fileTypesArray = allowedFileTypes.Value.toString().split(',');
        //check if file type is
        let ext = fileName.split('.')[1].toUpperCase();
        let count = fileTypesArray.length;
        for (let iter = 0; iter < count; iter++) {
            if (fileTypesArray[iter] == ext) {
                return iter;
            }
        }
        return -1;
    }

    checkFileSize(fileSize: number) {
        // get the maximum file size
        let allowedFileSize = environment.authWebApi.systemData.Configurations.find(
            (p) => p.Code == 'MaxUploadMB1'
        );
        let maxAllowedSize = allowedFileSize.Value; //it is in MB
        let document_sizeMB = fileSize / 1000000;
        if (document_sizeMB <= maxAllowedSize) {
            return 1;
        } else {
            return -1;
        }
        //
    }

    validateData(documenttypeid: any) {
        this.postFile(documenttypeid);
    }

    postFile(documenttypeid: any) {
        const formdata = new FormData();
        formdata.append('File', this.filebytes);
        formdata.append('FileName', this.filename);
        formdata.append('TypeOfFile', this.filetype);
        formdata.append('Notes', this.filedescription);
        formdata.append('FileSize', this.filesize);
        formdata.append('vehicleEntryId', this.selectItem.VehicleEntry.id);
        formdata.append('VehicleName', 'VehicalName - ' + this.filename);
        formdata.append('UserLastName', this.user.LastName);
        formdata.append('documenttypeid', documenttypeid);
        formdata.append('ApplicationId', this.appid);
        formdata.append('CarrierId', this.carrierId);

        this.isLoadingImg = true;
        this.isDocumentLoading = true;
        // this.message = 'Uploading... please wait'

        this.documentService
            .PostVehicleEntryDocument(
                formdata,
                documenttypeid,
                this.selectItem.VehicleEntry.id
            )
            .subscribe(
                (response) => {
                    this.documenttypeSerivce.getAll().subscribe((res: any) => {
                        //console.log(res);
                        this.uploadedDocs = [];
                        if (res != null && res.length > 0) {
                            this.uploadedDocs = res?.filter((x) => { return ((x.code !== 'SAID-PSS-NTS') && (x.code !== 'SARS-STAT ') && (x.code !== 'TRAV-ITIN') && (x.code !== 'MT-VH-LIC') && (x.is_for_vehicle == true)) });
                            this.getUploadDocs();
                        }
                    });
                    this.isLoadingImg = false;
                    //this.isLoading = false;
                    //console.log(response.document_type_id)
                    this.toastService.success(
                        'File: ' + this.filename + ' was successfully uploaded.',
                        'File Upload'
                    );
                },
                (error) => {
                    this.isLoadingImg = false;
                    this.isDocumentLoading = false;
                    this.toastService.error(
                        'File Upload Failed, Please try again.',
                        'Failed'
                    );
                    // this.reload()
                }
            );
    }

    postVehicleFiles(VehicleEntryId) {
        for (let item of this.DocumentsToUpload) {
            const formdata = new FormData();
            formdata.append('File', item.get('File'));
            formdata.append('FileName', item.get('file_name'));
            formdata.append('TypeOfFile', item.get('TypeOfFile'));
            formdata.append('Notes', item.get('Notes'));
            formdata.append('FileSize', item.get('FileSize'));
            formdata.append('vehicleEntryId', VehicleEntryId);
            formdata.append(
                'VehicleName',
                'VehicalName - ' + item.get('VehicleName')
            );
            formdata.append('UserLastName', item.get('UserLastName'));
            formdata.append('documenttypeid', item.get('documenttypeid'));
            formdata.append('ApplicationId', item.get('ApplicationId'));
            formdata.append('CarrierId',this.carrierId);

            this.isLoadingImg = true;
            this.isDocumentLoading = true;
            // this.message = 'Uploading... please wait'
            //this.selectItem.VehicleEntry.id = VehicleEntryId;

            this.documentService
                .PostVehicleEntryDocument(
                    formdata,
                    item.get('documenttypeid'),
                    VehicleEntryId
                )
                .subscribe(
                    (response) => {
                        this.documenttypeSerivce.getAll().subscribe((res: any) => {
                            //console.log(res);
                            this.uploadedDocs = [];
                            if (res != null && res.length > 0) {
                                this.uploadedDocs = res?.filter((x) => { return ((x.code !== 'SAID-PSS-NTS') && (x.code !== 'SARS-STAT ') && (x.code !== 'TRAV-ITIN') && (x.code !== 'MT-VH-LIC') && (x.is_for_vehicle == true)) });
                                this.getUploadDocs();
                            }
                        });
                        this.isLoadingImg = false;
                        //this.isLoading = false;
                        //console.log(response.document_type_id)
                        //1this.toastr.success('File: ' + this.filename + ' was successfully uploaded.', 'File Upload')
                    },
                    (error) => {
                        this.isLoadingImg = false;
                        this.isDocumentLoading = false;
                        this.toastService.error(
                            'File Upload Failed, Please try again.',
                            'Error'
                        );
                        // this.reload()
                    }
                );
                this.getApp(this.appid);
        }
        
        this.DocumentsToUpload = [];
        this.isLoadingImg = false;
    }

    removeUploadedDocTypes() {
        throw new Error('Method not implemented.');
    }

    getUploadDocs() {
        this.filename = '';
        if (this.selectItem != undefined) {
            this.documentService
                .getVehicleEntryDocById(this.selectItem.VehicleEntry.id)
                .subscribe(
                    (x: any) => {
                        this.viewDocuments = [];
                        if (x != null && x.length > 0) {
                            for (let list of x) {
                                let firstNum = list.document_link.indexOf('#');
                                //console.log(list.document_link.substring(firstNum + 1))
                                list.shareId = list.document_link.substring(firstNum + 1);
                                let docs: any = this.uploadedDocs?.filter((map) => {
                                    return map.id == list.document_type_id;
                                });
                                if (docs != null && docs.length > 0) {
                                    docs[0].document_link = list.document_link;
                                }
                            }
                            this.viewDocuments = x;
                        }
                        this.isDocumentLoading = false;
                    },
                    (error) => {
                        this.viewDocuments = [];
                        this.filename = '';
                        this.isDocumentLoading = false;
                    }
                );
        }
    }

    viewTempDoc(bytes, fileName) {
        console.log(bytes);
        this.isLoadingImg = true;
        this.pdfSrc = null;
        this.img = null;
        let ext = fileName.substring(fileName.length - 3, fileName.length);
        if (fileName.includes('.pdf')) {
            try {
                let response = this.base64ToArrayBuffer(bytes);
                let file = new Blob([response], {type: 'application/pdf'});
                var fileURL = URL.createObjectURL(file);
                this.pdfSrc = fileURL;
                this.img = null;

                this.isLoadingImg = false;
            } catch (e) {
                console.error(e);
            }

            return;
        }
    }

    base64ToArrayBuffer(base64: any): ArrayBuffer {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    }

    viewDoc(id, fileName) {
        this.isLoadingImg = true;
        this.pdfSrc = null;
        this.img = null;
        let ext = fileName.substring(fileName.length - 3, fileName.length);
        //console.log(ext);
        if (fileName.includes('.pdf')) {
            this.documentService.downloadpdf(id).subscribe((x) => {
                let objectURL = URL.createObjectURL(x);
                this.pdfSrc = objectURL;
                this.img = null;

                //this.pdfSrc = this.sanitizer.bypassSecurityTrustUrl(objectURL);
                //console.log(this.pdfSrc)
                this.isLoadingImg = false;
            });
            return;
        }
        this.documentService.download(id).subscribe((x) => {
            let objectURL = URL.createObjectURL(x);
            this.pdfSrc = null;
            this.img = this.sanitizer.bypassSecurityTrustUrl(objectURL);
            //console.log(this.img)
            this.isLoadingImg = false;
            // this.img = x;
        });
    }

    extraDoc(doc) {
        let list: any = this.uploadedDocs?.filter((map) => {
            return map.id == doc.document_type_id;
        });
        if (list != null && list.length > 0) {
            let object: any = JSON.parse(JSON.stringify(list[0]));
            object.document_link = null;
            this.uploadedDocs.push(object);
        }
        this.filename = '';
    }

    deleteTempDoc(doc) {
        this.confirmDialogService.confirmThis(
            'Are you sure you want to remove this document',
            () => {
                for (var i = this.viewDocuments.length - 1; i >= 0; --i) {
                    if (this.viewDocuments[i].file_name == doc.file_name) {
                        this.viewDocuments.splice(i, 1);
                    }
                }
            },
            () => {
                return;
            }
        );
    }

    deleteDoc(doc) {
        // this.showModal.showYesNo('Delete Document', 'Are you sure you want to delete?', `You're about to delete this document`, 'Yes', 'No')
        //   .subscribe((isConfirmed) => {
        //     if (isConfirmed) {
        //       this.deleteDocument(doc)
        //     } else {
        //       return;
        //     }
        //   });
        this.confirmDialogService.confirmThis(
            'Are you sure you want to delete this vehicle?',
            () => {
                this.deleteDocument(doc);
            },
            () => {
                return;
            }
        );
    }

    deleteDocument(item) {
        this.isDocumentLoading = true;
        this.documentService.DeleteVehicleEntryDoc(item.id).subscribe((res) => {
            this.documenttypeSerivce.getAll().subscribe((res: any) => {
                //console.log(res);
                this.uploadedDocs = [];
                if (res != null && res.length > 0) {
                    this.uploadedDocs = res?.filter(
                        (x) => { return ((x.code !== 'SAID-PSS-NTS') && (x.code !== 'SARS-STAT ') && (x.code !== 'TRAV-ITIN') && (x.code !== 'MT-VH-LIC') && (x.is_for_vehicle == true))}
                    );
                    this.getUploadDocs();
                }
            });
        });
    }

    changeCountry(countryId) {
        console.log(this.selectedCountry);
        const selectedId = this.mySelectedCountry.nativeElement.value;
        this.myForm.value.country_id = selectedId;
        this.found = false; // hides the 'Retrieve from eNatis' button
        this.selectedCountry = countryId.value;
        this.resetForm();
        if (countryId.value != '113') {
            this.enable();
        } else {
            this.isSouthAfrica = true;
            this.disable();

            //if selected country is SA disable the fields
            this.eNatisResult = true;
            // this.myForm.controls.registration_number.disable();
            // this.myForm.controls.vehicle_owner.disable();
            // this.myForm.controls.registration_year.disable();
            // this.myForm.controls.vehicle_colour.disable();
            // this.myForm.controls.vehicle_model.disable();
            // this.myForm.controls.gvn.disable();
            // this.myForm.controls.engine_number.disable();
            // this.myForm.controls.roadworthy_status.disable();
            // this.myForm.controls.eNatis_num.disable();
            // this.myForm.controls.date_license_expiry.disable();
            // this.myForm.controls.seating_capacity.disable();
            // this.myForm.controls.vehicle_make_id.disable();
            // // this.myForm.controls.vehicle_type_id.disable();
            // this.myForm.controls.is_leased.disable();
            // this.myForm.controls.vehicle_lessor.disable();
            // this.myForm.controls.vehicle_lessee.disable();
            // this.myForm.controls.date_lease_expiry.disable();
        }
        // else {
        //   this.isSouthAfrica = false;

        // this.myForm.controls.registration_number.enable();
        // this.myForm.controls.vehicle_owner.enable();
        // this.myForm.controls.registration_year.enable();
        // this.myForm.controls.vehicle_colour.enable();
        // this.myForm.controls.vehicle_model.enable();
        // this.myForm.controls.gvn.enable();
        // this.myForm.controls.engine_number.enable();
        // this.myForm.controls.roadworthy_status.enable();
        // this.myForm.controls.eNatis_num.enable();
        // this.myForm.controls.date_license_expiry.enable();
        // this.myForm.controls.seating_capacity.enable();
        // this.myForm.controls.vehicle_make_id.enable();
        // this.myForm.controls.vehicle_type_id.enable();
        // this.myForm.controls.is_leased.enable();
        // this.myForm.controls.vehicle_lessor.enable();
        // this.myForm.controls.vehicle_lessee.enable();
        // this.myForm.controls.date_lease_expiry.enable();
        // }
    }

    disable() {
        this.eNatisResult = true;
        // this.myForm.controls.registration_number.disable();
        // this.myForm.controls.vehicle_owner.disable();
        // this.myForm.controls.registration_year.disable();
        // this.myForm.controls.vehicle_colour.disable();
        // this.myForm.controls.vehicle_model.disable();
        // this.myForm.controls.gvn.disable();
        // this.myForm.controls.engine_number.disable();
        // this.myForm.controls.roadworthy_status.disable();
        // this.myForm.controls.eNatis_num.disable();
        // this.myForm.controls.date_license_expiry.disable();
        // this.myForm.controls.seating_capacity.disable();
        // this.myForm.controls.vehicle_make_id.disable();
        // this.myForm.controls.vehicle_type_id.disable();
        //this.myForm.controls.is_leased.disable();
        // this.myForm.controls.vehicle_lessor.disable();
        // this.myForm.controls.vehicle_lessee.disable();
        // this.myForm.controls.date_lease_expiry.disable();
    }

    enable() {
        // this.eNatisResult = false;
        // this.myForm.controls.registration_number.enable();
        //   this.myForm.controls.vehicle_owner.enable();
        //   this.myForm.controls.registration_year.enable();
        //   this.myForm.controls.vehicle_colour.enable();
        //   this.myForm.controls.vehicle_model.enable();
        //   this.myForm.controls.gvn.enable();
        //   this.myForm.controls.engine_number.enable();
        //  this.myForm.controls.roadworthy_status.enable();
        //   this.myForm.controls.eNatis_num.enable();
        //   this.myForm.controls.date_license_expiry.enable();
        //   this.myForm.controls.seating_capacity.enable();
        //   this.myForm.controls.vehicle_make_id.enable();
        //   this.myForm.controls.vehicle_type_id.enable();
        //   this.myForm.controls.is_leased.enable();
        //   this.myForm.controls.vehicle_lessor.enable();
        //   this.myForm.controls.vehicle_lessee.enable();
        //   this.myForm.controls.date_lease_expiry.enable();
    }

    resetForm() {
        this.eNatisResult = null;
        this.myForm.patchValue({
            vin: '',
            registration_number: '',
            engine_number: '',
            gvn: '',
            seating_capacity: '',
            registration_year: '',
            date_license_expiry: null,
            roadworthy_status: '',
            eNatis_num: '',
            vehicle_type_id: '',
            carrier_id: '',
            is_leased: '',
            vehicle_lessor: '',
            vehicle_lessee: '',
            date_lease_expiry: null,
            vehicle_owner: '',
            vehicle_colour: '',
            vehicle_model: '',
        });
        this.LeaseChange(event); // hides the lease container
        this.found = false; // hides the 'Retrieve from eNatis' button
        this.disallowEdit = false;
        this.myForm.controls.country_id.enable();
        this.myForm.controls.roadworthy_status.enable();
        this.myForm.controls.vehicle_type_id.enable();
        this.myForm.controls.is_leased.enable();
    }

    resetFormNotFound() {
        this.eNatisResult = null;
        this.myForm.patchValue({
            registration_number: '',
            engine_number: '',
            gvn: '',
            seating_capacity: '',
            registration_year: '',
            date_license_expiry: null,
            roadworthy_status: '',
            eNatis_num: '',
            vehicle_type_id: '',
            carrier_id: '',
            is_leased: '',
            vehicle_lessor: '',
            vehicle_lessee: '',
            date_lease_expiry: null,
            vehicle_owner: '',
            vehicle_colour: '',
            vehicle_model: '',
        });
    }

    close() {
        this.isSouthAfrica = false;
        this.disallowEdit = false;
        this.myForm.controls.country_id.enable();
        this.myForm.controls.roadworthy_status.enable();
        this.myForm.controls.vehicle_type_id.enable();
        this.myForm.controls.is_leased.enable();
    }

    checkVehicleClass(item) {
        this.wrongClass = false;
        var currentVehicleMeasure: number;
        var newVehicleMeasure: number;
        var result = this.permittypes.find((x) => x.id == this.curr_permit_type_id);
        if (this.currentVehicle != undefined) {
            var thisPermitType =
                result.freight_passenger_ind == 1 ? 'freight' : 'passenger';
            if (thisPermitType == 'passenger') {
                currentVehicleMeasure = this.currentVehicle.seating_capacity;
                newVehicleMeasure = item.VehicleEntry.seating_capacity;
                if (
                    (currentVehicleMeasure > 35 && newVehicleMeasure <= 35) ||
                    (currentVehicleMeasure <= 35 && newVehicleMeasure > 35)
                ) {
                    this.wrongClass = true;
                    this.classMessage = `------- Passenger Vehicles -------- Class 1 = seating capacity 35 or less Class 2 = seating capacity over 35`;
                }
            } else {
                currentVehicleMeasure = this.currentVehicle.gvn;
                newVehicleMeasure = item.VehicleEntry.gvn;
                if (
                    (currentVehicleMeasure > 20000 && newVehicleMeasure <= 20000) ||
                    (currentVehicleMeasure <= 20000 && newVehicleMeasure > 20000)
                ) {
                    this.wrongClass = true;
                    this.classMessage = `--------- Freight Vehicles --------- Class 1 = GVM of 20 000kg or less Class 2 = GVM more than 20 000kg`;
                }
            }
            if (this.wrongClass) {
                this.classMessage = `You can only replace a vehicle with another vehicle of the same class . . . ${this.classMessage}`;
            }
        }
        return this.wrongClass;
    }

    cabotageTrailer(vcleType) {
        // this.chkboxToolTip = 'Select vehicle to the application'
        if (vcleType == 'TRAILER') {
            let prmType = this.permittypes.find((p) => p.id == this.permit_type_id);
            if (prmType != undefined && prmType.code.substring(0, 3) != 'CAB') {
                // this.chkboxToolTip = `'TRAILER' is only applicable for 'Cabotage' permit types.`
                return true;
            }
        }
        return false;
    }

    chkboxToolTip(vcleType) {
        this.uploadedDocs = this.uploadedDocs?.filter(
            (x) => x.description !== 'Travel Itinerary'
        );
        if (vcleType == 'TRAILER') {
            let prmType = this.permittypes.find((p) => p.id == this.permit_type_id);
            if (prmType != undefined && prmType.code.substring(0, 3) != 'CAB') {
                return `'TRAILER' is only applicable for 'Cabotage' permit types.`;
            }
        }
        return 'Select vehicle to the application';
    }

    chkboxTool(event, item) {
        if (event.currentTarget.checked) {
            this.selectedVehicle = item;
        } else {
            this.selectedVehicle = null;
        }
    }

    onError(error: any) {
        // do anything
    }

    afterLoadComplete(pdf: PDFDocumentProxy) {
        //this.totalPages = pdf.numPages;
    }

    getYear(date: Date) {
        return this.datePipe.transform(date, 'y');
    }

    handleDropFileInput(event, id) {
        const reader = new FileReader();

        if (event && event.length > 0) {
            let file: any = null;
            const count = event.length;
            file = event[count - 1];
            let result = this.checkFileType(file.name);
            // item.document_type_id = this.docTypeData.id;
            // item.code = this.doctypesDesc.code
            // item.description=file.name;
            this.docTypeId = id;
            // this.uploadInfo.push(this.docTypeData);
            // localStorage.setItem('uploads',JSON.stringify(this.uploadInfo));
            const reader = new FileReader();

            if (event && event.length > 0) {
                let file: any = null;
                const count = event.length;

                file = event[count - 1];
                let result = this.checkFileType(file.name);

                //if File type is in not found
                if (result != -1) {
                    let sizeresult = this.checkFileSize(file.size);

                    if (sizeresult != -1) {
                        this.ref.detectChanges();

                        reader.removeEventListener;
                        reader.readAsDataURL(file);
                        reader.onload = () => {
                            this.filebytes = reader.result.toString().split(',')[1];
                            (this.filename = file.name), (this.filetype = file.type);
                            this.filedescription = 'upload';
                            this.filesize = file.size;
                            //  this.validateData(this.docTypeId);

                            const formdata = new FormData();
                            formdata.append('File', this.filebytes);
                            formdata.append('FileName', this.filename);
                            formdata.append('TypeOfFile', this.filetype);
                            formdata.append('Notes', this.filedescription);
                            formdata.append('FileSize', this.filesize);
                            // formdata.append('vehicleEntryId', this.selectItem.VehicleEntry.id);
                            formdata.append('VehicleName', 'VehicalName - ' + this.filename);
                            formdata.append('UserLastName', this.user.LastName);
                            formdata.append('documenttypeid', id);
                            formdata.append('ApplicationId', this.appid);
                            formdata.append('CarrierId', this.carrierId);
                            this.DocumentsToUpload.push(formdata);

                            let docs: any = this.uploadedDocs?.filter((map) => {
                                return map.id == this.docTypeId;
                            });
                            //this.uploadedDocs = docs;
                            if (docs != null && docs.length > 0) {
                                const originalDoc = docs[0]; // Assuming docs contains only one item
                                const clonedDoc = { ...originalDoc }; // Create a shallow copy
                            
                                // Modify the properties of the cloned document
                                clonedDoc.file_name = this.filename;
                                clonedDoc.document_type_id = this.docTypeId;
                                clonedDoc.document_link = this.filebytes;
                            
                                // Push the cloned document into this.viewDocuments
                                this.viewDocuments.push(clonedDoc);
                            }
                        };
                    } else {
                        // this.uploader.nativeElement.value = ''
                        let allowedFileSize =
                            environment.authWebApi.systemData.Configurations.find(
                                (p) => p.Code == 'MaxUploadMB1'
                            );
                        // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
                        this.toastService.error(
                            `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`,
                            'File Upload Failed, Please try again.'
                        );
                    }
                } else {
                    //send message allowed types
                    // this.uploader.nativeElement.value = ''
                    let allowedFileTypes =
                        environment.authWebApi.systemData.Configurations.find(
                            (p) => p.Code == 'UploadDocTypes1'
                        );

                    // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Only these file types are allowed  ${allowedFileTypes.Value.toString()}`, statuscode: '404',url: null, servermessage: "Extension not allowed"});
                    this.toastService.error(
                        `Only these file types are allowed: PDF`,
                        'File Upload Failed, Please try again.'
                    );
                    //Only these file types are allowed  ${allowedFileTypes.Value.toString()}
                }
            }
        }
    }

    actionClicked(optionVal, res) {
        console.log('Clicked Action');
        console.log(optionVal);
        console.log(res);

        this.selectedVehicle = res??this.selectedVehicle;

        switch (optionVal) {
            // Permits
            case 0: {
                console.log('Case0', this.selectedVehicles);
                this.isViewData = true;
                this.isEditData = false;
                this.editVehicle(this.selectedVehicle);
                this.myForm.controls.country_id.disable();
                this.myForm.controls.roadworthy_status.disable();
                this.myForm.controls.vehicle_type_id.disable();
                this.myForm.controls.is_leased.disable();
            }
                break;
            // Applications
            case 1: {
                console.log('Case1', this.selectedVehicles);
                this.isEditData = true;
                this.isViewData = false;
                this.editVehicle(this.selectedVehicle);
                this.myForm.controls.country_id.enable();
                this.myForm.controls.roadworthy_status.enable();
                this.myForm.controls.vehicle_type_id.enable();
                this.myForm.controls.is_leased.enable();

                // this.myForm.controls.carrier_id.enable();
            }
                break;
            // View Account
            case 2:
                this.uploadDocs(this.selectedVehicle);
                break;
            // Edit Account
            case 3:
                this.OndeleteVehicle(this.selectedVehicle);
                break;
            // Delete Account

            default:
                break;
        }
    }

    getVehiclesGVM() {
        this.permitTypeService.getVehiclesGVM().subscribe((data: any) => {
            this.vehicleGVMs = data;
            console.log('GVMs', this.vehicleGVMs);
        });
    }

    checkIfIdExists(id: number): boolean {
        return this.vehicleGVMs.some((item) => item.id === id);
    }

    @Output() prevStepEmitter = new EventEmitter<number>();
    @Output() nextStepEmitter = new EventEmitter<number>();
    @Input() isInStepper: boolean = false;
    nextStep(){
        this.nextStepEmitter.emit(0)
    }
    prevStep() {
        this.prevStepEmitter.emit(0)
    }

    // this.uploader.nativeElement.value = ''
    // this.showOtherUploadsOption = false;
}
